import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "groupBy",
  standalone: false,
})
export class GroupByPipe implements PipeTransform {
  transform(value: Array<any>, field: string): Array<any> {
    const groupedObj = value.reduce((prev, cur) => {
      if (field === "Submitted") {
        if (!prev[this.getDateField(new Date(cur[field]))]) {
          prev[this.getDateField(new Date(cur[field]))] = [cur];
        } else {
          prev[this.getDateField(new Date(cur[field]))].push(cur);
        }
        return prev;
      } else {
        if (!prev[cur[field]]) {
          prev[cur[field]] = [cur];
        } else {
          prev[cur[field]].push(cur);
        }
        return prev;
      }
    }, {});
    return Object.keys(groupedObj).map((key) => ({
      key,
      value: groupedObj[key],
    }));
  }

  private getDateField(input: Date): string {
    return (
      this.pad(input.getMonth() + 1) +
      "/" +
      this.pad(input.getDate()) +
      "/" +
      input.getFullYear()
    );
  }

  private pad(num: number): string {
    return ("00" + num.toString()).substr(-2);
  }
}
